import type { InsightQueueRow } from '@lib/insights/types/insight-queue-row';

export type RetryAction =
  | { type: 'reprocess'; documentId: string }
  | { type: 'client-retry' }
  | { type: 'blocked' };

/**
 * Decides how a rail retry click should be handled. A
 * clientId that matches a server row's documentId means the
 * upload already committed and only the pipeline needs to
 * re-run; anything else is still client-side and goes
 * through the upload queue instead.
 */
export function resolveRetryAction(
  clientId: string,
  serverRows: InsightQueueRow[]
): RetryAction {
  const serverRow = serverRows.find(row => row.documentId === clientId);
  if (!serverRow) return { type: 'client-retry' };
  if (!serverRow.isRetryable) return { type: 'blocked' };
  return { type: 'reprocess', documentId: serverRow.documentId };
}
